import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`

export const SelectedItemsWrapperTitle = styled.span`
  font-size: ${tokens.fontSize.small};
  color: ${tokens.colors.dark4};

  margin-top: ${tokens.spacing.verticalLarge};
`

export const SelectedItemsWrapper = styled.div<{ scrollable?: boolean }>`
  display: flex;
  flex-direction: row;

  margin-top: ${tokens.spacing.verticalSmall};
  padding: ${tokens.spacing.insetMedium};

  border: 1px solid ${tokens.colors.dark2};
  border-radius: ${tokens.radius.large};

  ${({ scrollable }) =>
    scrollable &&
    `
    flex: 1;
    min-height: 0;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 6px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${tokens.colors.dark2};
      border-radius: 3px;
    }
  `}
`

export const SelectedItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const SelectedItem = styled.span`
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.bold};
  color: ${tokens.colors.dark6};
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: ${tokens.spacing.verticalSmall};
  padding-top: ${tokens.spacing.verticalXlarge};
  flex-shrink: 0;
  margin-top: auto;
`

export const AlertWrapper = styled.div`
  margin-top: ${tokens.spacing.verticalXlarge};
`
